import { MQ_MAX_LARGE } from '@app/theme/types';
import { css, Theme } from '@emotion/react';

export const payHoursSubsection = (theme: Theme) =>
  css({
    borderRightWidth: '1px',
    borderColor: theme.colors.lightGrey,
    borderRightStyle: 'solid',
    paddingRight: '20px',
    [MQ_MAX_LARGE]: {
      borderRightWidth: '0',
      paddingRight: '0',
    },
  });
